<template>
  <el-dialog
    title="选择变更类型"
    ppend-to-body
    :visible="changeDialogVisible"
    :close-on-click-modal="false"
    center
    width="350px"
    @close="closeDialog"
  >
    <el-radio-group v-model="radio" class="tradeType">
      <el-radio v-for="(item, index) in options" :key="index" :label="item.value">{{
        item.label
      }}</el-radio>
    </el-radio-group>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading" @click="addSure()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'choiceChange',
    props: ['changeDialogVisible', 'changeContractId'],
    data() {
      return {
        radio: '',
        options: [
          { label: '变更合同信息', value: '0' },
          { label: '变更合同主体', value: '1' },
        ],
        loading: false,
      };
    },
    methods: {
      addSure() {
        if (this.radio == '') {
          return this.$message({
            showClose: true,
            message: '请选择变更类型',
            type: 'error',
          });
        }
        if (this.radio === '0') {
          // 变更合同信息
          const path = {
            path: 'propert/changeInfoLeaseContract',
            name: 'changeInfoLeaseContract',
            meta: {
              keepAlive: true,
              title: '变更合同信息',
            },
            query: {
              type: 'changeInfo',
              contractId: this.changeContractId,
            },
          };
          this.$router.push(path);
        }
        if (this.radio === '1') {
          // 变更合同主体
          const path = {
            path: 'propert/changeSubjectLeaseContract',
            name: 'changeSubjectLeaseContract',
            meta: {
              keepAlive: true,
              title: '变更合同主体',
            },
            query: {
              type: 'changeSubject',
              contractId: this.changeContractId,
            },
          };
          this.$router.push(path);
        }
        this.$emit('closeChangeDialog');
      },
      closeDialog() {
        this.$emit('closeChangeDialog');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tradeType {
    display: block;
    // width: 100%;
    margin-left: 30%;
    .el-radio {
      height: 30px;
      margin-right: 0px;
      display: block;
    }
  }
</style>
